<template>
  <div class="row step-details no-gutters">
    <div class="step-inputs col-lg-8">
      <div class="page-intro">
        <h3>Tell Us About You</h3>
      </div>
      <div class="subscriber-login" v-if="!isAuthenticated">
        <p>
          Already a customer?
          <a
            href="javascript:void(0)"
            @click="showLogin = !showLogin"
            class="login-link"
          >Log in here</a>, to populate this form.
        </p>
        <div class="login-form" v-if="showLogin">
          <vue-login></vue-login>
        </div>
      </div>

      <div class="subscriber-details">
        <!-- <span class="details">Your Details</span> -->
        <div style="position:relative">
          <span class="details">Your Details</span>
          <a class="clear-input" @click="clearForm">
            Clear
            <i class="fa fa-times"></i>
          </a>
        </div>
        <div class="form-group" v-bind:class="{ 'has-errors': errors.has('email_address') }">
          <input
            type="email"
            v-validate="'required|email'"
            name="email_address"
            class="form-control"
            data-vv-as="Email Address"
            v-model="subscriber.email_address"
            placeholder="Email Address"
          >
          <transition name="slide">
            <span class="error-message">{{ errors.first('email_address') }}</span>
          </transition>
        </div>

        <div class="form-group" v-bind:class="{ 'has-errors': errors.has('mobile_number') }">
          <the-mask
            type="tel"
            mask=" ### ### #### "
            v-validate="'required|digits:10'"
            name="mobile_number"
            class="form-control"
            data-vv-as="Mobile Number"
            v-model="subscriber.mobile_number"
            placeholder="Mobile Number"
          />
          <transition name="slide">
            <span
              class="error-message"
              v-if="errors.has('mobile_number')"
            >A valid 10 digit SA mobile number is required (eg: 076 123 4567).</span>
          </transition>
        </div>

        <div class="form-group" v-bind:class="{ 'has-errors': errors.has('first_name') }">
          <input
            type="text"
            v-validate="'required'"
            name="first_name"
            class="form-control"
            v-model="subscriber.first_name"
            data-vv-as="First Name"
            placeholder="First Name"
          >
          <transition name="slide">
            <span class="error-message">{{ errors.first('first_name') }}</span>
          </transition>
        </div>

        <div class="form-group" v-bind:class="{ 'has-errors': errors.has('last_name') }">
          <input
            type="text"
            v-validate="'required'"
            name="last_name"
            class="form-control"
            data-vv-as="Last Name"
            v-model="subscriber.last_name"
            placeholder="Last Name"
          >
          <transition name="slide">
            <span class="error-message">{{ errors.first('last_name') }}</span>
          </transition>
        </div>

         <div class="id-number">
          <div class="row">
            <div class="col-lg-6">
              <div class="form-group">
                <label>Identification Type?</label>
                <vue-toggle
                  :options="['ID','PASSPORT']"
                  :default="'ID'"
                  :selected.sync="subscriber.id_type"
                  class="row no-gutters"
                >
                  <template slot-scope="{item}">
                    <div class="col">
                      <button
                        type="button"
                        v-on:click="subscriber.id_type = item"
                        class="btn btn-default"
                        v-bind:class="['btn btn-block', subscriber.id_type != null && subscriber.id_type === item ? 'btn-primary': 'btn-outline-primary']"
                      >{{ item }}</button>
                    </div>
                  </template>
                </vue-toggle>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="form-group">
                 <label>{{subscriber.id_type + ' Number'}}</label>
               <the-mask
                  type="text"
                  :mask="subscriber.id_type == 'ID' ? '###### #### ###' : 'XXXXXXXXXXXXXXXXXXXXXXXXXX'"
                  v-validate="subscriber.id_type == 'ID' ? 'required|digits:13' : 'required|alpha_num'"
                  name="id_number"
                  class="form-control"
                  v-model="subscriber.id_number"
                  :data-vv-as="subscriber.id_type + ' Number'"
                  :placeholder="subscriber.id_type + ' Number'"
                />
                 <transition name="slide">
                  <span
                    class="error-message"
                    v-if="errors.has('id_number')"
                  >{{ errors.first('id_number') }}</span>
                </transition>
              </div>
            </div> 
          </div>
        </div> 

        <!-- <vue-port-details
        :details.sync="subscriber.port_details"
        ></vue-port-details> -->

        <div class="page-controls mt-5">
          <div class="row no-gutters">
            <!-- <button
              type="button"
              class="d-none d-sm-block col btn text-left btn-default back"
              v-on:click="backStep"
            >
              <i class="fa fa-chevron-left" aria-hidden="true"></i> Back
            </button> -->
            <button type="button" class="col btn btn-dark add-another" v-on:click="addAnotherSim" v-if="allowAnother">
              Add Another
              <i class="fa fa-plus" aria-hidden="true"></i>
            </button>

            <button type="button" class="col btn btn-primary next" v-on:click="checkout">
              Checkout
              <i class="fa fa-chevron-right" aria-hidden="true"></i>
            </button>
            <button
              type="button"
              class="d-block d-sm-none mt-3 col-12 btn btn-block btn-default back"
              v-on:click="backStep"
            >
              <i class="fa fa-chevron-left" aria-hidden="true"></i> Back
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 deal-info-content">
      <vue-deal-info />
    </div>
  </div>
</template>


<script>
import EventBus from "@/components/shared/event-bus";
import VueLogin from "@/components/elements/vue-login";
// import VuePortDetails from "@/components/elements/vue-port-details";
import VueDealInfo from "@/components/elements/vue-deal-info";
import { mapGetters } from "vuex";
import SubscriberModel from "@/models/subscriber.model";

export default {
  name: "subscriber-details",
  components: {
    "vue-deal-info": VueDealInfo,
    "vue-login": VueLogin,
    // "vue-port-details": VuePortDetails
  },
  computed: {
    ...mapGetters(["currentSimSubscriber", "isAuthenticated", "currentUser"])
  },
  props: ["builder", "allowAnother"],
  data: function() {
    return {
      subscriber: new SubscriberModel(self.currentSimSubscriber),
      showLogin: false
    };
  },
  methods: {
    clearForm() {
      var self = this;
      self.subscriber = new SubscriberModel();
    },
    addAnotherSim() {
      var self = this;
      self.$validator.validateAll().then(success => {
        if (success)
          EventBus.$emit("add-another-sim", { subscriber: self.subscriber });
        return success;
      });
    },
    checkout() {
      var self = this;
      self.$validator.validateAll().then(success => {
        if (success)                    
          EventBus.$emit("checkout", { subscriber: self.subscriber });
        return success;
      });
    },
    backStep() {
      EventBus.$emit("back-step", true);
    },
    isValidInputs() {
      this.$validator.validateAll().then(success => {
        return success;
      });
    },
    isEmpty(data) {
      return (
        data == null ||
        typeof data == "undefined" ||
        Object.keys(data).length === 0
      );
    }
  },
  watch: {
    subscriber: {
      handler(value) {
        var self = this;
        EventBus.$emit("subscriber-updated", value);
        if (value.port_details.port_number && value.port_details.number_to_port == null) {
          self.subscriber.port_details.number_to_port = value.mobile_number;
        }
      },
      deep: true
    },
    isAuthenticated(value, oldValue) {
      var self = this;
      if (value && self.currentUser) {
        self.subscriber = new SubscriberModel(self.currentUser);
      }

      if (!value && oldValue) self.subscriber = new SubscriberModel();
    }
  },
  mounted() {
    var self = this;
    self.$scrollTo("body");
    if (self.isAuthenticated && self.currentUser) {
      self.subscriber = new SubscriberModel(self.currentUser);
    }
  }
};
</script>